import React from "react";
import imageData from "../../json/containerthree";
import { Parallax, ParallaxBanner, ParallaxBannerLayer, ParallaxProvider } from "react-scroll-parallax";
import { useNavigate } from "react-router-dom";

const SectionThreeImageContainer = () => {
  const navigate = useNavigate();
  let fourtext = "";
  let btnstyle = "btn-style2";
  let fourtextdec = "";
  if (imageData[0].position === "start-position") {
    fourtext += "text-4xl md:text-6xl  text-black my-10 font-semibold w-96";
    btnstyle += " bg-white m-10 px-10 py-3 ";
    fourtextdec +=
      "text-sm text-black my-10 tracking-wider font-semibold w-96 leading-loose ";
  }
  return (
    <ParallaxProvider>
      <div>
        {imageData?.map((x, i) => (
          <ParallaxBanner
            style={{ aspectRatio: "2 / 1", height: "100vh" }}
            className="aspect-[2/1] parallax-container"
            key={i}
          >
            <ParallaxBannerLayer
              image={x.img}
              speed={-20}
              style={{ width: "100%", backgroundPosition: "center" }}
            />
            <Parallax className="relative h-full">
              <div className={`two-text-image `}>
                <p className={`${fourtext} pacifico-regular`}>{x.name}</p>
                <p className={`${fourtextdec}`}>{x.dec}</p>
                <div className={`btnstyle1`}>
                  <span
                    onClick={() => navigate("/category")}
                    className={`${btnstyle} cursor-pointer `}
                  >
                    {x.btn}
                  </span>
                </div>
              </div>
            </Parallax>
          </ParallaxBanner>
        ))}
      </div>
    </ParallaxProvider>
  );
};

export default SectionThreeImageContainer;
